import React from "react";
import { SwiperSlide } from "swiper/react";
import SwiperCarasoul from "../SwiperCarasoul";
import { NavLink, useNavigate } from "react-router-dom";
import { formatDate } from "date-fns";

const VenueCard = ({
  stepsDone,
  images,
  title,
  location,
  maxCapacity,
  Area,
  id,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    let url =
      stepsDone === 6 || stepsDone == undefined
        ? `/venue/id=${id}`
        : `/create-venue?id=${id}&step=${stepsDone}`;

    navigate(url);
  };

  return (
    <div className=" min-h-[292px] rounded-[20px] p-[16px] bg-white">
      <SwiperCarasoul data={images || []} />
      <div
        onClick={handleClick}
        className="cursor-pointer flex  items-center justify-between"
      >
        <h1 className="bg-clip-text text-transparent bg-gradient-to-t from-[#2E3E8D] to-[#4DB1E1] text-sm text-[18px] inline-block font-semibold my-[10px] w-[300px] truncate">
          {title || "Green Day 2025 Live in Expo City Dubai"}
        </h1>
        {stepsDone !== 6 && (
          <div className="flex gap-1 text-xs text-[#6256CA] "> In Progress</div>
        )}
      </div>

      <div className="flex gap-1 ">
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.6581 11.8741L3.11964 12.0664L2.6581 11.8741ZM2.10255 13.2074L2.56408 13.3997L2.10255 13.2074ZM13.8974 13.2074L13.4359 13.3997L13.8974 13.2074ZM13.3419 11.8741L13.8034 11.6818V11.6818L13.3419 11.8741ZM10.6666 10.5535C10.3905 10.5535 10.1666 10.7774 10.1666 11.0535C10.1666 11.3297 10.3905 11.5535 10.6666 11.5535V10.5535ZM5.33332 11.5535C5.60946 11.5535 5.83332 11.3297 5.83332 11.0535C5.83332 10.7774 5.60946 10.5535 5.33332 10.5535V11.5535ZM12.1666 6.46096C12.1666 7.60762 11.5141 8.97929 10.6032 10.0884C10.1538 10.6355 9.65991 11.0957 9.18752 11.4148C8.70439 11.7413 8.2936 11.8869 7.99998 11.8869V12.8869C8.58136 12.8869 9.19141 12.6191 9.74734 12.2435C10.314 11.8606 10.8774 11.3302 11.376 10.7231C12.3609 9.52383 13.1666 7.93253 13.1666 6.46096H12.1666ZM7.99998 11.8869C7.70636 11.8869 7.29557 11.7413 6.81245 11.4148C6.34005 11.0957 5.84613 10.6355 5.39679 10.0884C4.48589 8.97929 3.83332 7.60762 3.83332 6.46096H2.83332C2.83332 7.93253 3.63908 9.52383 4.62401 10.7231C5.12258 11.3302 5.68595 11.8606 6.25262 12.2435C6.80856 12.6191 7.4186 12.8869 7.99998 12.8869V11.8869ZM3.83332 6.46096C3.83332 4.11141 5.70619 2.22021 7.99998 2.22021V1.22021C5.13912 1.22021 2.83332 3.57403 2.83332 6.46096H3.83332ZM7.99998 2.22021C10.2938 2.22021 12.1666 4.11141 12.1666 6.46096H13.1666C13.1666 3.57403 10.8608 1.22021 7.99998 1.22021V2.22021ZM9.16665 6.38688C9.16665 7.03121 8.64431 7.55355 7.99998 7.55355V8.55355C9.1966 8.55355 10.1666 7.5835 10.1666 6.38688H9.16665ZM7.99998 7.55355C7.35565 7.55355 6.83332 7.03121 6.83332 6.38688H5.83332C5.83332 7.5835 6.80336 8.55355 7.99998 8.55355V7.55355ZM6.83332 6.38688C6.83332 5.74255 7.35565 5.22021 7.99998 5.22021V4.22021C6.80336 4.22021 5.83332 5.19026 5.83332 6.38688H6.83332ZM7.99998 5.22021C8.64431 5.22021 9.16665 5.74255 9.16665 6.38688H10.1666C10.1666 5.19026 9.1966 4.22021 7.99998 4.22021V5.22021ZM2.19656 11.6818L1.64101 13.0151L2.56408 13.3997L3.11964 12.0664L2.19656 11.6818ZM3.33332 15.5535H12.6666V14.5535H3.33332V15.5535ZM14.359 13.0151L13.8034 11.6818L12.8803 12.0664L13.4359 13.3997L14.359 13.0151ZM12.1111 10.5535H10.6666V11.5535H12.1111V10.5535ZM3.88887 11.5535H5.33332V10.5535H3.88887V11.5535ZM13.8034 11.6818C13.5187 10.9986 12.8512 10.5535 12.1111 10.5535V11.5535C12.4475 11.5535 12.7509 11.7558 12.8803 12.0664L13.8034 11.6818ZM12.6666 15.5535C13.9749 15.5535 14.8621 14.2227 14.359 13.0151L13.4359 13.3997C13.6646 13.9486 13.2613 14.5535 12.6666 14.5535V15.5535ZM1.64101 13.0151C1.13784 14.2227 2.02509 15.5535 3.33332 15.5535V14.5535C2.73867 14.5535 2.33537 13.9486 2.56408 13.3997L1.64101 13.0151ZM3.11964 12.0664C3.24903 11.7558 3.55245 11.5535 3.88887 11.5535V10.5535C3.14875 10.5535 2.48122 10.9986 2.19656 11.6818L3.11964 12.0664Z"
            fill="#AFB1B9"
          />
        </svg>

        <span className="text-[12px] text-[#AFB1B9]">
          {location || "Dubai-United Arab Emirates"}
        </span>
      </div>
      <div className="flex gap-1 mt-2 justify-between items-center">
        <div className="flex gap-1">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="12"
              cy="8"
              r="3"
              stroke="#AFB1B9"
              strokeWidth="1.5"
              fill="none"
            />
            <circle
              cx="6"
              cy="10"
              r="2.5"
              stroke="#AFB1B9"
              strokeWidth="1.5"
              fill="none"
            />
            <circle
              cx="18"
              cy="10"
              r="2.5"
              stroke="#AFB1B9"
              strokeWidth="1.5"
              fill="none"
            />
            <path
              d="M5 16C5 14.3431 6.34315 13 8 13H16C17.6569 13 19 14.3431 19 16V17H5V16Z"
              stroke="#AFB1B9"
              strokeWidth="1.5"
              fill="none"
            />
            <path
              d="M2 18C2 16.3431 3.34315 15 5 15H6"
              stroke="#AFB1B9"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18 15H19C20.6569 15 22 16.3431 22 18"
              stroke="#AFB1B9"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="text-[0.8rem] text-[#AFB1B9] flex gap-2 items-center">
            MAX Capacity{" "}
            <p className="text-[#3b57e4] font-light">{maxCapacity}</p>
          </span>
        </div>
        <div className="flex gap-1 items-center justify-center">
          <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
            <rect
              x="2"
              y="2"
              width="14"
              height="14"
              fill="lightblue"
              stroke="black"
              stroke-width="0.5"
            />

            <line
              x1="2"
              y1="2"
              x2="16"
              y2="12"
              stroke="black"
              stroke-width="0.5"
            />
          </svg>

          <span className="text-[14px] text-[#AFB1B9] flex gap-2 items-center">
            Area (Sqm). <p className="text-[#3b57e4] font-light">{Area}</p>
          </span>
        </div>
      </div>
    </div>
  );
};

export default VenueCard;
